<template>
  <div class="home detail-actions-page">
    <div class="px-8 py-4">
      <!-- Header -->
      <div class="detail-page-header mb-4">
        <button type="button" class="btn btn-link text-decoration-none detail-page-back" @click="$router.go(-1)" style="padding: 10px 0">
          <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-2" />{{$t('back')}}
        </button>
        <div class="detail-page-title-row d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <h3 class="detail-page-title mb-0">{{ category.name || $t('category') }}</h3>
          <div class="detail-page-actions">
            <button v-if="helper.checkAccess('edit_categories') != -1" @click="editRow()" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs detail-page-action--secondary">
              <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
              {{$t('edit')}}
            </button>
            <button v-if="helper.checkAccess('delete_categories') != -1" @click="deleteRow()" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs detail-page-action--danger">
              <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
              {{$t('delete')}}
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="text-center" style="padding:2rem">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Category Info -->
      <div v-else-if="category && category.id">
        <!-- Tabs -->
        <ul class="nav nav-tabs detail-page-tabs mb-4">
          <li class="nav-item">
            <a class="nav-link" :class="{active: step === 'overview'}" @click="step = 'overview'">{{$t('overview')}}</a>
          </li>
          <li class="nav-item" v-if="helper.checkAccess('view_inventories') != -1">
            <a class="nav-link" :class="{active: step === 'products'}" @click="step = 'products'">{{$t('products')}}</a>
          </li>
        </ul>

        <!-- Tab Content -->
        <!-- Overview Tab -->
        <div v-if="step === 'overview'">
          <div v-if="helper.checkAccess('view_inventories') != -1" class="mb-4">
            <h5 class="mb-3"><AppIcon name="bi-lightbulb" class="bi bi-lightbulb me-2" />{{$t('insights')}}</h5>
            <inventory-statistics
              :inventories="inventories"
              :total-products="categoryProducts.length"
            ></inventory-statistics>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- Description Card -->
              <div v-if="category.description" class="card">
                <div class="card-header bg-white">
                  <h6 class="mb-0"><AppIcon name="bi-sticky" class="bi bi-sticky me-2" />{{$t('description')}}</h6>
                </div>
                <div class="card-body">
                  <p class="mb-0">{{ category.description }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Products Tab -->
        <div v-if="step === 'products' && helper.checkAccess('view_inventories') != -1">
          <product-component v-if="category && category.id" :category_id="category.id" :category="category" :isDetailClient="true"></product-component>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import helper from '../../helper'
import InventoryStatistics from '../../components/InventoryStatistics.vue'
import ProductComponent from '../product/Product.vue'

export default {
  name: 'categoryDetails',
  components :{
    InventoryStatistics,
    ProductComponent,
  },
  data(){
    return {
        loading: false,
        category : {},
        total : 0,
        step : 'overview',
        amount_paid : 0,
        total_orders : 0,
        total_quote : 0,
        total_deliveries : 0,
        total_invoices : 0
    }
  },
  created(){
    if(!this.$route.params || !this.$route.params.id) return this.$route.push('/categories')
    this.getcategory(this.$route.params.id)
  },
  mounted(){
    window.mixpanel.track("category_details");
    
    //check permissions
    if(helper.checkAccess('view_categories') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_categories') == -2) return this.$router.push({path : '/subscribe'})
  },
    methods : {
        async getcategory(id){
        try{
            this.loading = true
            const response = await helper.customGet(`${process.env.VUE_APP_API}/categories/${id}`)
            this.category = response.data
            this.loading = false
            
        }catch(error){
            this.$router.push({path : '/categories'})
            this.loading = false
        }
        },
        editRow(){
            // TODO: Implement edit functionality
            this.$toast.open({
                message: this.$t('feature_coming_soon'),
                type: 'info',
                position: 'bottom'
            })
        },
        async deleteRow(){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await helper.customDelete(`${process.env.VUE_APP_API}/categories/${this.category.id}`)
                        this.$router.push({path : '/categories'})
                    } catch(error) {
                        this.$toast.open({
                            message: error.response?.data?.message || this.$t('error_deleting_category'),
                            type: 'error',
                            position: 'bottom'
                        })
                    }
                }
            })
        },
        formatDate(date) { return helper.formatDate(date) },
        formatMoney(number) { return helper.formatMoney(number);}
    },
    computed : {
        business(){ return this.$store.getters.BUSINESS},
        helper(){ return helper; },
        categoryProducts() {
            return Array.isArray(this.category.products) ? this.category.products : []
        },
        inventories() {
            return this.categoryProducts.reduce((inventories, product) => {
                const productInventories = Array.isArray(product.inventories) ? product.inventories : []
                return inventories.concat(productInventories.map(inventory => ({
                    ...inventory,
                    product: {
                        id: product.id,
                        label: product.label,
                        reference: product.reference
                    }
                })))
            }, [])
        }
    }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .nav-link {
        cursor: pointer;
    }
</style>
